
const AboutSection = () => {
  return (
    <>
      {/* من نحن */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Image */}
            <div>
              <div className="relative rounded-3xl overflow-hidden h-[500px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/4212fe3f1b098ce5ee1758cbe15d7a71.jpg"
                  alt="من نحن"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Content */}
            <div>
              <h2 className="text-4xl font-bold text-accent mb-6">من نحن</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                خياط الأقمشة الكويتية هو وجهتك الأولى للحصول على أجود أنواع الأقمشة المستوردة وأفضل خدمات التفصيل في الكويت. نفخر بخبرتنا الممتدة لأكثر من 15 عاماً في خدمة عملائنا الكرام.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                نحرص على انتقاء أفضل الأقمشة من أشهر المصانع العالمية، ونقدم خدمات تفصيل احترافية تلبي جميع الأذواق والمناسبات. رضاكم هو هدفنا الأول.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-2xl shadow-sm">
                  <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-medal-line text-2xl text-secondary"></i>
                  </div>
                  <h3 className="text-xl font-bold text-accent mb-2">خبرة طويلة</h3>
                  <p className="text-gray-600">أكثر من 15 عاماً في خدمة العملاء</p>
                </div>

                <div className="bg-white p-6 rounded-2xl shadow-sm">
                  <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-team-line text-2xl text-secondary"></i>
                  </div>
                  <h3 className="text-xl font-bold text-accent mb-2">فريق محترف</h3>
                  <p className="text-gray-600">خياطون ذوو خبرة ومهارة عالية</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* الرؤية والرسالة */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* الرؤية */}
            <div className="bg-gray-50 p-10 rounded-3xl">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-3xl font-bold text-accent mb-4">رؤيتنا</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                أن نكون الخيار الأول والأفضل في الكويت لتوفير أجود الأقمشة وأرقى خدمات التفصيل، مع الحفاظ على التراث والأصالة في كل قطعة نقدمها.
              </p>
            </div>

            {/* الرسالة */}
            <div className="bg-gray-50 p-10 rounded-3xl">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-flag-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-3xl font-bold text-accent mb-4">رسالتنا</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                تقديم أفضل الأقمشة المستوردة وخدمات التفصيل الاحترافية بأعلى معايير الجودة، مع ضمان رضا عملائنا الكرام وتلبية احتياجاتهم بكل دقة واهتمام.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* لماذا تختارنا */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-accent mb-4">لماذا تختارنا</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              نقدم لك أفضل تجربة في عالم الأقمشة والتفصيل
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-vip-crown-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-2xl font-bold text-accent mb-4">جودة استثنائية</h3>
              <p className="text-gray-600 leading-relaxed">
                نختار أقمشتنا بعناية فائقة من أفضل المصانع العالمية لضمان الجودة والمتانة
              </p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scissors-cut-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-2xl font-bold text-accent mb-4">تفصيل احترافي</h3>
              <p className="text-gray-600 leading-relaxed">
                فريق من الخياطين المحترفين ذوي الخبرة الطويلة في التفصيل الدقيق
              </p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-2xl font-bold text-accent mb-4">التزام بالمواعيد</h3>
              <p className="text-gray-600 leading-relaxed">
                نحرص على تسليم طلباتك في الوقت المحدد مع إمكانية التفصيل المستعجل
              </p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-price-tag-3-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-2xl font-bold text-accent mb-4">أسعار منافسة</h3>
              <p className="text-gray-600 leading-relaxed">
                نقدم أفضل الأسعار مع الحفاظ على أعلى معايير الجودة والخدمة
              </p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-customer-service-2-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-2xl font-bold text-accent mb-4">خدمة عملاء مميزة</h3>
              <p className="text-gray-600 leading-relaxed">
                فريق خدمة عملاء متاح دائماً للرد على استفساراتك ومساعدتك
              </p>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-secondary"></i>
              </div>
              <h3 className="text-2xl font-bold text-accent mb-4">ضمان الجودة</h3>
              <p className="text-gray-600 leading-relaxed">
                نضمن لك جودة الأقمشة والتفصيل مع إمكانية التعديل حتى رضاك التام
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
